<div class="professional-list-page">
  <header>
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-tab-group
          class="benefits-tabs"
          (selectedIndexChange)="onBenefitTabIndexChange($event)"
          [(selectedIndex)]="selectedBenefitTabIndex"
        >
          <mat-tab
            class="benefit-tab"
            [label]="benefit"
            *ngFor="let benefit of professionalsSearchParam.benefits"
          >
            <ng-template mat-tab-label>
              <mat-icon>folder</mat-icon>{{ benefit }}
            </ng-template>
          </mat-tab>
        </mat-tab-group>

        <div class="intensive-button-wrapper" *ngIf="showAddSearchButton">
          <button
            *ngIf="enableDeepSearch()"
            class="intensive-search-button"
            mat-stroked-button
            color="warn"
            (click)="disableDeepSearch()"
          >
            <mat-icon>arrow_back</mat-icon>
            Back to Search
          </button>
        </div>
      </mat-card-header>

      <mat-card-content>
        <div class="search-grid-container">
          <mat-form-field class="mat-form-field" appearance="outline">
            <mat-label>Province</mat-label>
            <mat-select
              (click)="onUserInteractChange()"
              [(value)]="selectedProvince"
              (selectionChange)="onProvinceSelected($event.value)"
            >
              <mat-option
                *ngFor="let province of filteredProvinces"
                [value]="province"
                >{{ province }}</mat-option
              >
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field" appearance="outline">
            <mat-label>Profession</mat-label>
            <mat-select
              (click)="onUserInteractChange()"
              [(value)]="selectedProfession"
              (selectionChange)="onProfessionSelected($event.value)"
              [disabled]="!hasMinimumSearchQueryParams"
            >
              <mat-option [value]="null">(All)</mat-option>
              <mat-option
                *ngFor="let profession of filteredProfessions"
                [value]="profession"
              >
                {{ profession }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field" appearance="outline">
            <mat-label>Specialty</mat-label>
            <mat-select
              (click)="onUserInteractChange()"
              [(value)]="selectedSpecialty"
              (selectionChange)="onSpecialtySelected($event.value)"
              [disabled]="!hasMinimumSearchQueryParams"
            >
              <mat-option [value]="null">(All)</mat-option>
              <mat-option
                *ngFor="let specialty of filteredSpecialties"
                [value]="specialty"
              >
                {{ specialty }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field
            appearance="outline"
            class="mat-form-field provider-name"
            *ngIf="!enableDeepSearch()"
          >
            <mat-label>Name</mat-label>
            <input
              matInput
              [(ngModel)]="selectedName"
              (keydown.enter)="searchPaginatedProfessionals(false, true)"
              [disabled]="!hasMinimumSearchQueryParams"
            />
            <button
              *ngIf="selectedName"
              class="clear-name-icon-button"
              mat-icon-button
              matSuffix
              aria-label="Clear"
              (click)="clearName()"
            >
              <mat-icon class="small-icon">close</mat-icon>
            </button>
          </mat-form-field>

          <div class="deep-search-fields" *ngIf="enableDeepSearch()">
            <mat-form-field class="first-name" appearance="outline">
              <mat-label>First Name</mat-label>
              <input
                matInput
                #firstNameInput
                [value]="addSearchFirstName()"
                (input)="addSearchFirstName.set($any($event.target).value)"
              />
              <button
                *ngIf="addSearchFirstName()"
                class="clear-name-icon-button"
                mat-icon-button
                matSuffix
                aria-label="Clear"
                (click)="addSearchFirstName.set('')"
              >
                <mat-icon class="small-icon">close</mat-icon>
              </button>
            </mat-form-field>

            <mat-form-field class="last-name" appearance="outline">
              <mat-label>Last Name</mat-label>
              <input
                matInput
                #lastNameInput
                [value]="addSearchLastName()"
                (input)="addSearchLastName.set($any($event.target).value)"
                aria-label="Clear"
              />
              <button
                *ngIf="addSearchLastName()"
                class="clear-name-icon-button"
                mat-icon-button
                matSuffix
                aria-label="Clear"
                (click)="addSearchLastName.set('')"
              >
                <mat-icon class="small-icon">close</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <div class="show-concerns-toggle" *ngIf="!enableDeepSearch()">
            <p>Concerns</p>
            <mat-slide-toggle
              [(ngModel)]="showConcernsOnly"
              [disabled]="!hasMinimumSearchQueryParams"
              [attr.aria-label]="
                showConcernsOnly ? 'search concerns only' : 'search all types'
              "
            >
              <span class="accessibility-aria-label-hidden">Concerns</span>
            </mat-slide-toggle>
          </div>

          <mat-card-actions class="search-actions">
            <button
              mat-button
              class="search-button"
              (click)="searchPaginatedProfessionals(true, true)"
              [disabled]="!hasMinimumSearchQueryParams"
              *ngIf="!enableDeepSearch()"
            >
              Search
            </button>
            <button
              *ngIf="enableDeepSearch()"
              mat-button
              class="search-button"
              (click)="handleRequestSearch()"
              [disabled]="!canSubmitDeepSearch || loading"
            >
              Request a Name Search
            </button>

            <button
              *ngIf="!enableDeepSearch()"
              class="underlined-button"
              mat-button
              (click)="clear()"
            >
              Clear search
            </button>
          </mat-card-actions>
        </div>

        <div
          class="paginator-container"
          [ngClass]="{
            disabled: enableDeepSearch()
          }"
        >
          <p><strong>Results:</strong></p>
          <mat-paginator
            #paginator
            [pageSizeOptions]="[20, 50, 100]"
            aria-label="Select page of professionals"
            (page)="searchPaginatedProfessionals(false, true)"
            [disabled]="
              !hasMinimumSearchQueryParams ||
              this.paginator.length == 0 ||
              enableDeepSearch()
            "
          ></mat-paginator>
          <button
            class="export-button"
            mat-icon-button
            color="accent"
            (click)="export()"
            [disabled]="matDataSource.data.length === 0"
            matTooltip="Export results"
            aria-label="Export results"
          >
            <mat-icon>download</mat-icon>
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </header>
  <main>
    <section *ngIf="enableDeepSearch()" class="intensive-search-messages">
      <div class="instructions">
        <div class="pre-request" *ngIf="deepSearchStatus() === 'idle'">
          <h3 class="message">
            Please enter
            <strong> Province, Profession, First Name and Last Name.</strong>
          </h3>
          <h4 class="message">
            We will search on the regulatory body website.
          </h4>
        </div>
        <div class="post-request" *ngIf="deepSearchStatus() === 'error'">
          <h3 class="message">
            Sorry, we had problems to process your request. <br />
            Please try again.
          </h3>
        </div>
        <div class="post-request" *ngIf="deepSearchStatus() === 'success'">
          <h3 class="message">Success, we submitted your search request.</h3>
          <h4 class="message icon">
            Please hold on while we process your request. This may take up to
            <mat-icon>timer</mat-icon> 10 minutes.
          </h4>
          <h4 class="message">
            Once completed, simply search again for the name you just entered.
            <br />
            You can continue using the app in the meantime.
          </h4>

          <div class="actions">
            <button
              *ngIf="enableDeepSearch()"
              class="intensive-search-button"
              mat-stroked-button
              color="warn"
              (click)="disableDeepSearch()"
            >
              Back to Search
            </button>
          </div>
        </div>
      </div>
    </section>
    <section
      *ngIf="!enableDeepSearch()"
      class="results-list"
      [ngClass]="{
        expanded: !selectedProfessional
      }"
    >
      <mat-form-field
        class="filter-field"
        appearance="outline"
        *ngIf="matDataSource.data.length > 0"
      >
        <input
          #input
          matInput
          (keyup)="applyFilter($event)"
          placeholder="Filter the results"
        />
      </mat-form-field>

      <div class="table-container">
        <!-- No Results -->
        <h2 class="message" *ngIf="matDataSource.data.length == 0 && !loading">
          {{ resultsMessage }}
        </h2>

        <div class="no-results-try-add-search" *ngIf="showAddSearchButton">
          <h3 class="invite-message">
            Try to <strong>Request a Name Search </strong>in the regulatory body
            website
          </h3>
          <button
            *ngIf="!enableDeepSearch()"
            class="intensive-search-button lightblue"
            mat-stroked-button
            color="accent"
            (click)="enableDeepSearchForm()"
            [disabled]="!selectedProvince"
          >
            Request a Name Search
          </button>
        </div>

        <!-- Results -->
        <table
          *ngIf="matDataSource.data.length > 0 && !enableDeepSearch()"
          mat-table
          [dataSource]="matDataSource"
          matSort
          class="results-table"
          tabindex="0"
          (keydown)="onKeydown($event)"
        >
          <ng-container matColumnDef="results">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Results list
            </th>
            <td
              mat-cell
              *matCellDef="let professional"
              [ngClass]="{
                'selected-row-indicator':
                  professional?.id === selectedProfessional?.id
              }"
            >
              <div class="details-row-box">
                <div
                  class="box"
                  [ngClass]="{
                    'extended-box': selectedProfessional
                  }"
                >
                  <p
                    *ngIf="professional?.name"
                    [ngClass]="{
                      'selected-name':
                        professional?.id === selectedProfessional?.id
                    }"
                  >
                    <strong>{{ professional.name }}</strong>
                  </p>
                </div>

                <div class="box" *ngIf="!selectedProfessional">
                  <div *ngIf="professional?.profession">
                    <p>
                      Profession:
                      {{ professional.profession }}
                    </p>
                  </div>
                  <div *ngIf="professional?.licenceType">
                    <p>
                      License type:
                      {{ professional.licenceType }}
                    </p>
                  </div>
                </div>

                <div class="box shortened" *ngIf="!selectedProfessional">
                  <div *ngIf="professional?.status">
                    <p>
                      Status:
                      {{ professional.status }}
                    </p>
                  </div>
                  <div>
                    <p *ngIf="professional.workplaces[0]?.provider?.name">
                      Workplace:
                      {{ professional.workplaces[0]?.provider?.name }}

                      <span
                        *ngIf="
                          professional.workplaces.length > 1 &&
                          professional?.workplaces[1]?.provider
                        "
                      >
                        and {{ professional.workplaces.length - 1 }} more
                      </span>
                    </p>
                  </div>
                  <div *ngIf="professional?.registrationNumber">
                    <p>
                      Registration number:
                      {{ professional?.registrationNumber }}
                    </p>
                  </div>
                  <div
                    *ngIf="
                      formatAuthorizations(
                        professional?.authorizations
                      ) as authorizations
                    "
                  >
                    <p *ngIf="authorizations.length > 0">
                      Authorizations:
                      {{ trimEffectiveDate(authorizations[0]) }}
                      <span *ngIf="authorizations.length > 1">
                        and {{ authorizations.length - 1 }} more
                      </span>
                    </p>
                  </div>
                </div>

                <div class="box" *ngIf="!selectedProfessional">
                  <p>
                    Concerns:
                    {{ professional.hasConcerns ? "Yes" : "No" }}
                  </p>
                </div>

                <div class="box tr" *ngIf="selectedProfessional">
                  <p class="mt-10">
                    Concerns:
                    {{ professional.hasConcerns ? "Yes" : "No" }}
                  </p>
                </div>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="
              let professional;
              columns: displayedColumns;
              let i = index
            "
            (click)="openDetails(professional, i)"
            [id]="'row-' + professional.id"
          ></tr>
        </table>
      </div>
    </section>

    <mat-card
      appearance="outlined"
      class="details-container"
      *ngIf="selectedProfessional && !enableDeepSearch()"
    >
      <div class="details-title">
        <div class="title">
          <h3>
            {{ selectedProfessional?.name }}
            <span>
              <a
                *ngIf="formatUrl(selectedProfessional?.url) as professionalUrl"
                [href]="professionalUrl"
                [matTooltip]="professionalUrl"
                target="_blank"
                class="link-with-icon"
                rel="noopener"
                aria-label="Opens in a new tab"
              >
                <mat-icon class="mat-icon-small">open_in_new</mat-icon>
              </a>
            </span>
          </h3>
        </div>
        <button mat-icon-button aria-label="Close" (click)="onCloseDetails()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <mat-card-content class="details-card-content">
        <app-professional-details-view
          [professional]="selectedProfessional"
          [province]="selectedProvince"
        ></app-professional-details-view>
      </mat-card-content>
    </mat-card>
  </main>
</div>
